import type { FilterConfigBarItemDefault } from '@rocco/ui/filter-sort/types/filter-config-bar';
import type { MultipleValuesFilterState } from '@rocco/ui/filter-sort/view-models/filter-state/multiple-values-filter-state';
import type { FilterBarElementProps } from '@rocco/ui/filter-sort/components/filters-bar/FiltersBarElement';
import { useFiltersContext } from '@rocco/ui/filter-sort/components/Filters';
import { Checkbox as RoccoCheckbox } from '@rocco/components/checkbox';
import { Label as RoccoLabel } from '@rocco/components/label';

export const FiltersBarMultipleValues = (
    props: FilterBarElementProps<
        FilterConfigBarItemDefault,
        MultipleValuesFilterState
    >,
) => {
    const { filterState, onFilterStateUpdate } = props;
    const {
        searchFilters: { handleToggleMultipleValues },
    } = useFiltersContext();

    return (
        <div className="flex flex-col gap-2">
            {filterState.items.map((item, index) => (
                <div
                    key={index}
                    className="group flex h-8 cursor-pointer items-center rounded-2 border border-transparent px-2 hover:border-black hover:bg-primary-foreground hover:text-primary"
                    onClick={() => {
                        if (handleToggleMultipleValues) {
                            onFilterStateUpdate(
                                handleToggleMultipleValues(
                                    filterState,
                                    item,
                                    !item.checked,
                                ),
                                true,
                            );
                        }
                    }}
                >
                    <RoccoCheckbox
                        id={item.value}
                        checked={item.checked}
                        groupHover="light"
                    />

                    <RoccoLabel htmlFor={item.value} target="checkbox">
                        {item.label}
                    </RoccoLabel>
                </div>
            ))}
        </div>
    );
};
